import { useMemo } from 'react';
import { SelectRootProps, useRecipe, useSlotRecipe } from '@chakra-ui/react';

import { getReactSelectStylesOverrides } from './logic/getReactSelectStylesOverrides';

export const useControlledSelectStyles = (props: Partial<SelectRootProps>) => {
  const selectRecipe = useSlotRecipe({ key: 'select' });
  const [selectVariantProps] = selectRecipe.splitVariantProps(props);

  const inputRecipe = useRecipe({ key: 'input' });
  const { variant: _variant, ...propsWithoutVariant } = props;
  const [inputVariantProps] =
    inputRecipe.splitVariantProps(propsWithoutVariant);

  const styles = useMemo(
    () =>
      getReactSelectStylesOverrides(
        selectRecipe(selectVariantProps),
        inputRecipe(inputVariantProps),
      ),
    [selectRecipe, inputRecipe, selectVariantProps, inputVariantProps],
  );

  return styles;
};
